import { Alert } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { ErrorAlert } from '@sportybot-web/components/alerts/error';
import { RuleForm } from '@sportybot-web/features/rules/components/rule-form/rule-form';
import { ruleParamsSchema } from '@sportybot-web/features/rules/schemas/rule-params';
import { putRuleMutationOptions } from '@sportybot-web/services/sporty-gateway/rules/mutations';
import { ruleKeys, ruleQueryOptions } from '@sportybot-web/services/sporty-gateway/rules/queries';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';

/* eslint-disable perfectionist/sort-objects */
export const Route = createFileRoute('/_authenticated/rules/$ruleId')({
  component: RouteComponent,
  params: { parse: ruleParamsSchema.parse },
  errorComponent: ErrorAlert,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { ruleId } = params;
    return queryClient.ensureQueryData(ruleQueryOptions(ruleId));
  },
});
/* eslint-enable perfectionist/sort-objects */

function RouteComponent() {
  const queryClient = useQueryClient();
  const { ruleId } = useParams({ from: Route.id });
  const { data } = useSuspenseQuery({ ...ruleQueryOptions(ruleId), select: (data) => data.rule });
  const { error, isPending, mutate: putRule } = useMutation(putRuleMutationOptions());

  if (!data) {
    return <Alert title="Rule Not Found">The rule you are looking for does not exist.</Alert>;
  }

  return (
    <RuleForm
      key={data.ruleId}
      loading={isPending}
      onSubmit={(values, form) => {
        putRule(
          { rule: { ...values, username: data.username } },
          {
            onSuccess: ({ putRule }) => {
              void queryClient.invalidateQueries({ queryKey: [ruleKeys.all] });
              void queryClient.invalidateQueries({
                queryKey: ruleKeys.detail(Number(putRule?.ruleId)),
              });
              notifications.show({
                color: 'green',
                message: 'Your rule has successfully been updated',
                title: 'Rule Updated',
              });
              form.resetDirty();
            },
          },
        );
      }}
      rule={data}
      serverError={error ? { error, title: 'Rule Update Failed' } : null}
    />
  );
}
